import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  CustomCollapseCard,
  CustomPagination,
  CustomTable,
  Text,
  CustomImage,
  useText,
} from '@src/components';

import { moneyFormat } from '@src/utils/utils';
import { useMediaQuery } from '@src/hooks/useMediaQuery';

import { getInstructionsDetailsPageList } from '@src/store/slice/autoUploadInstructionsSlice';

import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons';
import cardsRegistered from '@src/assets/icons/icon-cards-registered.svg';

import '@src/styles/autoUploadInstruction/cardDetailInformation.scss';
import * as PropTypes from 'prop-types';

function getExpandIcon() {
  return ({ expanded, onExpand, record }) =>
    expanded ? (
      <UpCircleOutlined
        className="autoUploadInstruction-up-circle-outlined"
        style={{ fontSize: '24px' }}
        onClick={(e) => onExpand(record, e)}
      />
    ) : (
      <DownCircleOutlined
        className="autoUploadInstruction-down-circle-outlined"
        style={{ fontSize: '24px' }}
        onClick={(e) => onExpand(record, e)}
      />
    );
}

function getExpandedRowRender() {
  return (record) => {
    return (
      <div className="custom-expanded-row" key={record.id}>
        <div className="colum-title">
          <span>
            <Text t="referenceCode2" />:
          </span>
          <span>{record.refNo}</span>
        </div>
        <div className="colum-title">
          <span>
            <Text t="cardNumber2" />:
          </span>
          <span>{record.cardNumber}</span>
        </div>
        <div className="colum-title">
          <span>
            <Text t="totalBalanceToBeLoadedVatIncluded" />:
          </span>
          <span> {moneyFormat(record.price, false)} ₺</span>
        </div>
      </div>
    );
  };
}

function EditDetailPage(props) {
  return (
    <CustomCollapseCard
      className="autoUploadInstruction-instruction-card-detail-information-collapse"
      cardTitle={<Text t="userListToLoadBalance" />}
    >
      <div className="card-information">
        {props.totalAutoLoading?.totalCount} <Text t="totalCreditAmountForUser3" />
        <span className="card-information-price">
          {moneyFormat(props.totalAutoLoading?.totalPrice, true)}
        </span>
      </div>

      <CustomTable
        pagination={false}
        dataSource={props.dataSource}
        columns={props.columns}
        rowKey={props.rowKey}
        expandable={{
          showExpandColumn: true,
          expandIconColumnIndex: 37,
          onExpand: props.onExpand,
          expandIcon: props.mobil ? getExpandIcon() : null,
          expandedRowRender: props.mobil ? getExpandedRowRender() : null,
        }}
      />

      <CustomPagination
        current={props.detailTableProperty?.currentPage}
        defaultCurrent={1}
        pageSize={props.detailTableProperty?.pageSize}
        total={props.detailTableProperty?.totalCount}
        onChange={props.onChange}
      />
    </CustomCollapseCard>
  );
}

EditDetailPage.propTypes = {
  totalAutoLoading: PropTypes.any,
  dataSource: PropTypes.any,
  columns: PropTypes.arrayOf(PropTypes.any),
  rowKey: PropTypes.func,
  onExpand: PropTypes.func,
  mobil: PropTypes.bool,
  detailTableProperty: PropTypes.any,
  onChange: PropTypes.func,
};

function ConfirmDetailPage(props) {
  return (
    <div className="autoUploadInstruction-instruction-card-detail-information-collapse integrationId-table">
      <CustomTable
        pagination={false}
        dataSource={props.dataSource}
        columns={props.columns}
        rowKey={props.rowKey}
        expandable={{
          showExpandColumn: true,
          expandIconColumnIndex: 37,
          onExpand: props.onExpand,
          expandIcon: props.mobil ? getExpandIcon() : null,
          expandedRowRender: props.mobil ? getExpandedRowRender() : null,
        }}
      />

      <div className="integrationId-footer">
        <CustomPagination
          current={props.detailTableProperty?.currentPage}
          defaultCurrent={1}
          pageSize={props.detailTableProperty?.pageSize}
          total={props.detailTableProperty?.totalCount}
          onChange={props.onChange}
        />
        <div className="card-information integrationId-footer-card-information">
          <div className="integrationId-footer-card-information-count">
            <CustomImage src={cardsRegistered} />
            <p>
              <Text t="total" />
              <span>{props.totalAutoLoading?.totalCount}</span> <Text t="orderTitle" />
            </p>
          </div>
          <p className="card-information-price integrationId-footer-card-information-price">
            <Text t="totalAmountToBeLoadedColon" />{' '}
            <span>{moneyFormat(props.totalAutoLoading?.totalPrice, true)}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

ConfirmDetailPage.propTypes = {
  dataSource: PropTypes.any,
  columns: PropTypes.arrayOf(PropTypes.any),
  rowKey: PropTypes.func,
  onExpand: PropTypes.func,
  mobil: PropTypes.bool,
  detailTableProperty: PropTypes.any,
  onChange: PropTypes.func,
  totalAutoLoading: PropTypes.any,
};
const CardDetailInformation = () => {
  const isMobil = useMediaQuery({ query: '(max-width: 1199.98px)' });

  const dispatch = useDispatch();
  const history = useHistory();

  const [expandedRowsInvocies, setExpandedRowsInvocies] = useState([]);

  const { detailList, detailTableProperty, totalAutoLoading, autoLoadingId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );
  const params = new URLSearchParams(history.location.search);
  let integrationId = params.get('updateId') || params.get('instructionId') || 0;
  integrationId = parseInt(integrationId);
  let isUpdate = integrationId !== 0;

  const addParam = {
    integrationId: isUpdate && integrationId === 0 ? integrationId : 0,
    autoLoadingId: autoLoadingId,
  };

  useEffect(async () => {
    await dispatch(
      getInstructionsDetailsPageList({
        body: addParam,
        filter: { showOnlyPriced: true },
      }),
    );
  }, [history, dispatch]);

  let columns = [];

  const referenceCodeTitle = useText('referenceCode3');
  const cardNumberTitle = useText('cardNumber4');
  const totalBalanceTitle = useText('totalBalanceToBeLoadedVatIncludedUpperCase');

  params.get('instructionId') &&
    columns.push({
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: 35,
      render: (_, __, index) =>
        (detailTableProperty?.currentPage - 1) * detailTableProperty?.pageSize + index + 1,
    });

  columns.push(
    {
      title: useText('nameUpperCase'),
      dataIndex: 'name',
      key: 'name',
      width: 100,
    },
    {
      title: useText('surnameUpperCase'),
      dataIndex: 'surname',
      key: 'surname',
      width: 125,
    },
  );

  !isMobil &&
    columns.push(
      {
        title: referenceCodeTitle,
        dataIndex: 'refNo',
        key: 'refNo',
        width: 150,
        align: 'center',
      },
      {
        title: cardNumberTitle,
        dataIndex: 'cardNumber',
        key: 'cardNumber',
        width: 150,
        align: 'center',
      },
      {
        title: totalBalanceTitle,
        dataIndex: 'price',
        key: 'price',
        width: 150,
        align: 'right',
        render: (text) => <span>{moneyFormat(text, false)}</span>,
      },
    );

  const loadInstructionsDetailsPageList = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(
        getInstructionsDetailsPageList({
          body: addParam,
          filter: { showOnlyPriced: true },
          pageSize,
          pageNumber,
        }),
      );
    },
    [dispatch],
  );

  const handleTableChange = useCallback(
    async (pageNumber, pageSize) => {
      await loadInstructionsDetailsPageList(pageNumber, pageSize);
    },
    [loadInstructionsDetailsPageList],
  );

  return params.get('instructionId') ? (
    <EditDetailPage
      totalAutoLoading={totalAutoLoading}
      dataSource={detailList}
      columns={columns}
      rowKey={(record) => `${record?.id}`}
      onExpand={(expanded, record, key) =>
        expandedRowsInvocies === key ? setExpandedRowsInvocies(null) : setExpandedRowsInvocies(key)
      }
      mobil={isMobil}
      detailTableProperty={detailTableProperty}
      onChange={async (pageNumber, pageSize) => {
        await handleTableChange(pageNumber, pageSize);
      }}
    />
  ) : (
    <ConfirmDetailPage
      dataSource={detailList}
      columns={columns}
      rowKey={(record) => `${record?.id}`}
      onExpand={(expanded, record, key) =>
        expandedRowsInvocies === key ? setExpandedRowsInvocies(null) : setExpandedRowsInvocies(key)
      }
      mobil={isMobil}
      detailTableProperty={detailTableProperty}
      onChange={async (pageNumber, pageSize) => {
        await handleTableChange(pageNumber, pageSize);
      }}
      totalAutoLoading={totalAutoLoading}
    />
  );
};

export default CardDetailInformation;
